<template>
  <div class="memu">
    <!-- 菜单 -->
      <div class="my-menu">
        <dl @click="$router.push('/perfect')">
          <dt>
            <img src="../../assets/images/my-img/6.png" alt="">
          </dt>
          <dd>完善信息</dd>
        </dl>
        <dl @click="payBtn">
          <dt>
            <img src="../../assets/images/my-img/1.png" alt="">
          </dt>
          <dd>充值</dd>
        </dl>
        <dl @click="$router.push('/wallet')">
          <dt>
            <img src="../../assets/images/my-img/3.png" alt="">
          </dt>
          <dd>钱包</dd>
        </dl>
        <dl @click="orderBtn">
          <dt>
            <img src="../../assets/images/my-img/7.png" alt="">
          </dt>
          <dd>我的订单</dd>
        </dl>
        <dl @click="myjifenBtn">
          <dt>
            <img src="../../assets/images/my-img/5.png" alt="">
          </dt>
          <dd>康养积分</dd>
        </dl>
        <!-- <dl @click="$router.push('/card-ecommend')">
          <dt>
            <img src="../../assets/images/my-img/rights-and-interests.png" alt="">
          </dt>
          <dd>卡权益</dd>
        </dl> -->
        <dl @click="$router.push('/brokerage')">
          <dt>
            <img src="../../assets/images/my-img/2.png" alt="">
          </dt>
          <dd>佣金</dd>
        </dl>
        <dl @click="share_option_btn">
          <dt>
            <img src="../../assets/images/my-img/4.png" alt="">
          </dt>
          <dd>期权</dd>
        </dl>
        <dl @click="$router.push('/pay-record')">
          <dt>
            <img src="../../assets/images/my-img/8.png" alt="">
          </dt>
          <dd>业主钱包</dd>
        </dl>
        <dl @click="$router.push('/jifen')">
          <dt>
            <img src="../../assets/images/my-img/80.png" alt="">
          </dt>
          <dd>合伙人积分</dd>
        </dl>
        <!-- <dl @click="$router.push('/write-msg')">
          <dt>
            <img src="../../assets/images/my-img/hehuo.png" alt="">
          </dt>
          <dd>申请合伙人</dd>
        </dl> -->
      </div>
  </div>
</template>
<script>
export default {
  data(){
    return{

    }
  },
  props:{
    card_msg:{
      type : Array
    }
  },
  methods:{
    // 充值
    payBtn(){
      this.$router.push('/pay')
    },
    // 订单
    orderBtn(){
      this.$router.push('/order-list')
    },
    // 粉丝
    fansBtn(){
      // console.log(this.card_msg.realname)
      this.$router.push({
        path:'/fans',
        // query:{
        //   realname : this.card_msg.realname
        // }
      })
    },
    myjifenBtn(){
      this.$router.push({
        path:'/my-jifen/',
        // query:{
        //   realname : this.card_msg.realname
        // }
      })
    },
    share_option_btn(){
      this.$router.push({
        path:'/returns-detailed/job-options',
        query:{
          // realname : this.card_msg.realname
          id : 1
        }
      })
    }
    
  }
}
</script>
<style lang="less" scoped>
  // 菜单
  .my-menu{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    dl{
      width: 33%;
      margin-top: .4rem;
      dt{
        width: .96rem;
        height: .96rem;
        margin: 0 auto;
        img{
          width: .96rem;
          height: .96rem;
        }
      }
      dd{
        font-family: PingFang-SC-Bold;
        color: #333333;
        font-size: .28rem;
        text-align: center;
        font-weight: bold;
        margin-top: .1rem;
      }
    }
  }
</style>